import { useEffect, useState } from 'react';
import { subscribeToServerNotifications } from '../services/apiConnectionService';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

// Subscribes admin/manager users to the `api_notifications` Firestore
// collection populated by the Cloud Run polling service. The actual API
// polling no longer runs in the browser.
const ApiPollingManager = () => {
  const [shouldListen, setShouldListen] = useState(false);

  useEffect(() => {
    const checkUserRole = async () => {
      const user = auth.currentUser;
      if (!user) {
        setShouldListen(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userRole = userDoc.data().role;
          setShouldListen(userRole === 'administrator' || userRole === 'manager');
        } else {
          setShouldListen(false);
        }
      } catch (error) {
        console.error('Error checking user role for API notifications:', error);
        setShouldListen(false);
      }
    };

    checkUserRole();
  }, []);

  useEffect(() => {
    if (!shouldListen) return undefined;

    let unsubscribe;
    try {
      unsubscribe = subscribeToServerNotifications();
    } catch (error) {
      if (error.code === 'permission-denied') {
        console.log('API notifications not available for this user role');
      } else {
        console.error('Error subscribing to API notifications:', error);
      }
    }

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [shouldListen]);

  return null;
};

export default ApiPollingManager;
